import { useState } from 'react';

export type ClientFormTabId = 'information' | 'criteria';

export const useClientFormTabs = () => {
  const [activeTab, setActiveTab] = useState<ClientFormTabId>('information');

  const goToNextTab = () => {
    if (activeTab === 'information') {
      setActiveTab('criteria');
    }
  };

  return {
    activeTab,
    setActiveTab,
    goToNextTab,
  };
};